import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { api, formatApiError } from "@/lib/apiClient";

export default function Feedback() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ customer_name: "", customer_email: "", rating: 5, title: "", body: "", product_name: "" });
  useEffect(() => { api.get("/reviews").then((r) => setList(r.data || [])); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/reviews", { ...form, rating: Number(form.rating) });
      toast.success("Thanks for the feedback! We review every entry.");
      setForm({ customer_name: "", customer_email: "", rating: 5, title: "", body: "", product_name: "" });
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div data-testid="feedback-page" className="section-pad">
      <div className="container-pp grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Customer Feedback</div>
          <h1 className="editorial-h1 text-5xl md:text-6xl mt-3">Tell us what you really think.</h1>
          <p className="mt-6 text-brand-charcoal/70 leading-relaxed">Reviews shape our next batch. Suggest a flavour, flag a problem or just say thanks — we read every one.</p>
        </div>
        <form className="lg:col-span-7 card-elevated p-8 space-y-5" onSubmit={submit} data-testid="feedback-form">
          <div className="grid sm:grid-cols-2 gap-5">
            <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Your Name</label><input data-testid="fb-name" className="pp-input" required value={form.customer_name} onChange={(e)=>setForm({...form, customer_name:e.target.value})} /></div>
            <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Email (optional)</label><input type="email" data-testid="fb-email" className="pp-input" value={form.customer_email} onChange={(e)=>setForm({...form, customer_email:e.target.value})} /></div>
            <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Product</label><input data-testid="fb-product" className="pp-input" value={form.product_name} onChange={(e)=>setForm({...form, product_name:e.target.value})} placeholder="e.g. Alphonso Sunrise" /></div>
            <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Rating</label>
              <div className="flex gap-1 mt-2" data-testid="fb-stars">
                {[1,2,3,4,5].map((n)=>(<button type="button" key={n} data-testid={`fb-star-${n}`} onClick={()=>setForm({...form, rating:n})} className="p-1"><Star size={22} className={n<=form.rating ? "fill-brand-yellow stroke-brand-yellow" : "stroke-brand-charcoal/35"} /></button>))}
              </div>
            </div>
          </div>
          <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Headline</label><input data-testid="fb-title" className="pp-input" value={form.title} onChange={(e)=>setForm({...form, title:e.target.value})} /></div>
          <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Your review</label><textarea data-testid="fb-body" rows="4" className="pp-input" required value={form.body} onChange={(e)=>setForm({...form, body:e.target.value})} /></div>
          <button data-testid="fb-submit" className="btn-pill btn-dark">Submit Review</button>
        </form>
      </div>

      <div className="container-pp mt-24" data-testid="feedback-wall">
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">What customers say</div>
        <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((r) => (
            <div key={r.id} className="card-elevated p-6">
              <div className="flex justify-between items-center">
                <div className="text-sm font-medium">{r.customer_name}</div>
                <div className="text-brand-yellow">{"★".repeat(r.rating || 5)}</div>
              </div>
              {r.title && <div className="font-display text-2xl mt-2 leading-tight">{r.title}</div>}
              <p className="mt-3 text-sm text-brand-charcoal/70 leading-relaxed">{r.body}</p>
              {r.product_name && <div className="mt-3 text-[10px] uppercase tracking-[0.22em] text-brand-charcoal/50">{r.product_name}</div>}
            </div>
          ))}
          {list.length === 0 && <div className="text-brand-charcoal/60">Be the first to leave a review.</div>}
        </div>
      </div>
    </div>
  );
}
